class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.overlay = this.querySelector('[data-cart-drawer-overlay]');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.onKeyUp = (evt) => evt.code === 'Escape' && this.close();

    if (this.notification) {
      this.querySelectorAll('[data-cart-drawer-close]').forEach((closeButton) =>
        closeButton.addEventListener('click', this.close.bind(this))
      );
    }

    if (this.overlay) {
      this.overlay.addEventListener('click', this.close.bind(this));
    }
  }

  open() {
    if (!this.notification) return;

    this.notification.hidden = false;
    if (this.overlay) this.overlay.hidden = false;

    requestAnimationFrame(() => {
      this.notification.classList.add('animate', 'active');
      if (this.overlay) this.overlay.classList.add('active');
      document.body.classList.add('cart-drawer-open');
    });

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
    document.addEventListener('keyup', this.onKeyUp);
  }

  refreshAndOpen() {
    const sectionIds = this.getSectionsToRender().map((section) => section.id);
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const url = `${root}?sections=${sectionIds.join(',')}`;

    return fetch(url)
      .then((response) => response.json())
      .then((sections) => {
        this.getSectionsToRender().forEach((section) => {
          const el = document.getElementById(section.id);
          if (!el || !sections[section.id]) return;
          el.innerHTML = this.getSectionInnerHTML(sections[section.id], section.selector);
        });
        this.open();
      })
      .catch(() => {
        this.open();
      });
  }

  close() {
    if (!this.notification) return;

    this.notification.classList.remove('active');
    if (this.overlay) this.overlay.classList.remove('active');
    document.body.classList.remove('cart-drawer-open');

    document.body.removeEventListener('click', this.onBodyClick);
    document.removeEventListener('keyup', this.onKeyUp);
    removeTrapFocus(this.activeElement);

    const onEnd = () => {
      this.notification.hidden = true;
      if (this.overlay) this.overlay.hidden = true;
      this.notification.removeEventListener('transitionend', onEnd);
    };
    this.notification.addEventListener('transitionend', onEnd);
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const el = document.getElementById(section.id);
      if (!el || !parsedState.sections || !parsedState.sections[section.id]) return;
      el.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        // Full cart line list (not only the just-added item)
        selector: '.shopify-section'
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const root = new DOMParser().parseFromString(html, 'text/html');
    const el = root.querySelector(selector) || root.querySelector('.shopify-section') || root.body;
    return el ? el.innerHTML : '';
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (
      target === this.overlay ||
      (target !== this.notification &&
        !target.closest('cart-notification') &&
        !target.closest('#cart-icon-bubble'))
    ) {
      const disclosure = target.closest('details-disclosure');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);

window.openThemeCartDrawer = function openThemeCartDrawer(options) {
  const drawer = document.querySelector('cart-notification');
  if (!drawer) return false;
  if (options && options.refresh && typeof drawer.refreshAndOpen === 'function') {
    drawer.refreshAndOpen();
    return true;
  }
  if (typeof drawer.open === 'function') {
    drawer.open();
    return true;
  }
  return false;
};
